import { useState } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Preloader from "@/components/feature/Preloader";
import { SiteDataProvider } from "@/contexts/SiteDataContext";

function App() {
  const [preloaderDone, setPreloaderDone] = useState(false);

  return (
    <I18nextProvider i18n={i18n}>
      <SiteDataProvider>
        {!preloaderDone && (
          <Preloader onComplete={() => setPreloaderDone(true)} />
        )}
        <div
          style={{
            opacity: preloaderDone ? 1 : 0,
            transition: 'opacity 0.5s ease-in-out',
            visibility: preloaderDone ? 'visible' : 'hidden',
          }}
        >
          <BrowserRouter basename={typeof __BASE_PATH__ === 'string' && !__BASE_PATH__.startsWith('.') ? __BASE_PATH__ : undefined}>
            <AppRoutes />
          </BrowserRouter>
        </div>
      </SiteDataProvider>
    </I18nextProvider>
  );
}

export default App;